import React from "react";
import Weather from "./components/Weather";
import "./App.scss";

function App() {
  return (
    <>
      <main>
        <Weather />
      </main>
    </>
  );
}

export default App;
